import { useQuery } from '@tanstack/react-query';
import type { AuditLogEntry } from '@wrapforce/shared';
import { workspacePath } from '@wrapforce/shared/api-client';
import { api } from '@/lib/api';

export function useAuditLogs(workspaceId: string | null, enabled: boolean) {
  return useQuery({
    queryKey: [workspaceId, 'audit-logs'],
    queryFn: () => api.get<{ items: AuditLogEntry[]; nextCursor: string | null }>(workspacePath(workspaceId!, '/audit-logs')),
    enabled: !!workspaceId && enabled,
    staleTime: 15_000,
  });
}
